import * as ComponentConstants from "../constants/ComponentConstants";

export default {
	// initiële state bij het starten van de app.
	// Evt defaults in opnemen
	ajaxCounter: 0,
	exception: {
		exception: null,
		redirectToExceptionPage: false
	},
	settings: {
		apiRoot: '', // root to the api site, including /api
		siteRoot: '', // root to the portal
		subsidiesWebAppRoot: '', // root to the parent subsidies app
		helpdeskContactLink: "",
		sportDBUrl: '',
		fileTypes: {},
		maxAllowedContentLength: "",
		accountId: "",
		accountType: "",
		disabled: false
	},
	security: {
		activeFederatieId: '',
		activeKwartaalId: '',
		activeKwartaalNaam: ''
	},
	validatieStatussen: [],
	layout: {
		pageHeaderTitle: "Nado",
		pageHeaderSubtitle: "",
		activeTopNavItemId: "1",
		showHeader: false,
		showTopNav: true,
		showSimpleTopNav: false,
		disableSimpleTopNav: true,
		showBeads: false,
		scope: "default",
		topNavTabsSet: false,
		topNavTabSettings: {
			organisatie: { text: "Organisatie", color: ComponentConstants.COLOR_BLUE, iconType: ComponentConstants.ICON_ORGANISATIE, disabled: false, visible: true, urlSuffix: "/organisatie/" }
		},
		topNavPrefix: "",
		showSideNav: false,
		sideNavItems: [], // {id: "1", display: "SideNav Example 1", linkEnabled: true }
		sideNavPrefix: ""
	},
	referentie: {
		geslachten: [],
		controleInstanties: [],
		sporterTypes: [],
		sporterStatussen: [],
		soortenKampioenschap: [],
		sporttakken: [],
		sportdisciplines: [],
		portaalTeksten: []
	}
};